// 生成guid值方法
function S4() {  
  return (((1+Math.random())*0x10000)|0).toString(16).substring(1);  
}

export default {
  // 生成guid
  guid(){
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());  
  },
  // 获取服务器地址
  getServerUrl(){
    const serverIp = localStorage.getItem("serverIp")
    let baseUrl = "/api"
    if(serverIp){
        baseUrl = `http://${serverIp}:${localStorage.getItem('serverPort')}`
    }
    return baseUrl
  }
}